module.exports = __webpack_public_path__ + "static/media/soundAlpha1.28a84d77.mp3";